export const AnnouncementType = {
  Ad: 'Ad', // 此類型是廣告版位的 第8點 - 公告彈窗廣告位
  System: 'System', // 此類型是系統公告
}
